import React, { useCallback } from 'react'
import { actionButtonsColumnProps, BsrsGrid, Column, EnumCell, LookupCell } from '@/components/BsrsGrid'
import { Button } from '@/components/button'
import { openDialog } from '@/store/Dialogs'
import { dialogTypes } from '@/dialogs'
import { useLocalization } from '@/hooks/localization'
import { useDispatch } from '@/hooks/dispatch'
import { WhiteBox } from '@/components/Layout'
import { institutionTypes } from '@/enums/institutionTypes'

export function InputReportPermissions ({ reportGroupPermissions, onChange, jobPositionAssignmentId }) {
  const { localize } = useLocalization()
  const handleAdd = useCallback(({ item }) => {
    onChange([...reportGroupPermissions, item])
  }, [reportGroupPermissions, onChange])
  const handleEdit = useCallback(({ item, dataIndex }) => {
    const index = dataIndex - 1
    const items = reportGroupPermissions.map((x, idx) => {
      if (idx === index) { return item }
      return x
    })
    onChange(items)
  }, [reportGroupPermissions, onChange])

  const [showDialog] = useDispatch([openDialog])
  const onAddClick = useCallback(() => showDialog({
    dialogType: dialogTypes.reportGroupPermission,
    reportGroupPermission: { id: 0, jobPositionAssignmentId },
    onAction: handleAdd
  }), [handleAdd, showDialog, jobPositionAssignmentId])

  const actionProps = actionButtonsColumnProps([
    { icon: 'pencil',
      onClick: (item, dataIndex) => {
        showDialog({
          dialogType: dialogTypes.reportGroupPermission,
          reportGroupPermission: item,
          dataIndex,
          onAction: handleEdit
        })
      }
    },
    {
      onDelete: (item, dataIndex) => {
        onChange(reportGroupPermissions.filter((x, idx) => idx !== dataIndex - 1))
      }
    }
  ])

  return (
    <WhiteBox
      header={localize('Permissions.ReportInstanceGroupsPermissions')}
      buttons={<Button icon='plus' color='primary' className='btn-sm' onClick={onAddClick}>{localize('Common.Add')}</Button>}
      transparent headerClass='no-uppercase'>
      <BsrsGrid items={reportGroupPermissions} simpleView>
        <Column field='institutionType' title={localize('Permissions.InstitutionType')} cell={EnumCell({ localize, enumName: institutionTypes.enumName })} />
        <Column field='institution' title={localize('Permissions.Institution')} cell={LookupCell} />
        <Column field='bankType' title={localize('Permissions.BankType')} cell={LookupCell} />
        <Column field='companyType' title={localize('Permissions.CompanyType')} cell={LookupCell} />
        <Column field='reportGroup' title={localize('Permissions.ReportGroup')} cell={ReportGroupCell} />
        <Column title={' '} {...actionProps} />
      </BsrsGrid>
    </WhiteBox>
  )
}

function ReportGroupCell ({ field, dataItem }) {
  const { localize } = useLocalization()
  const name = (dataItem.reportGroup || {}).name || localize('Common.All')
  return (
    <td>{name}</td>
  )
}



// WEBPACK FOOTER //
// ./src/internal-app/pages/jobPositionPermissions/inputReportPermissions.js